import React, { useState, useEffect } from 'react';
import { useSession } from '../context/SessionContext';
import { toast } from 'react-toastify';
import '../styles/ManageRolesPage.css';
import Panel from '../components/Panel';
import axios from '../services/axiosConfig';


const ConfigExternalRoles = () => {
  const { sessionData } = useSession();
  // API URL from environment variable only
  const API_URL = process.env.REACT_APP_API_URL;

     const [isExternalRolesPanelOpen, setIsExternalRolesPanelOpen] = useState(true);
 // State for config external roles
  const [internalRoles, setInternalRoles] = useState([]);
   const [configSelectedInternalRole, setConfigSelectedInternalRole] = useState(null);
   const [configExternalRoles, setConfigExternalRoles] = useState([]);
   const [configFilteredExternalRoles, setConfigFilteredExternalRoles] = useState([]);
   const [configExternalRolesFilter, setConfigExternalRolesFilter] = useState('');
   const [configMappedExternalRoles, setConfigMappedExternalRoles] = useState([]);   
    const [selectedMappedRoles, setSelectedMappedRoles] = useState([]);
const [selectedMappedRole, setSelectedMappedRole] = useState(null);
  // Define the state and function for toggling the panel
  const [isPanelOpen, setIsPanelOpen] = useState(true);
  
  const togglePanel = () => {
    setIsPanelOpen((prevState) => !prevState);
  };    // Update the logic to fetch and populate internal roles dropdown
  useEffect(() => {
    const loadInternalRoles = async () => {
      try {
        const response = await axios.get(`${API_URL}/ConfigExternalRoles/LoadInternalRoles`);
        const roles = response.data.internalRoles;

        // Transform data for dropdown
        const options = roles.map(role => ({
          id: role.id,
          roleName: role.roleName
        }));

        setInternalRoles(options);
      } catch (error) {
        console.error('Error loading internal roles:', error);
        // toast.error('Failed to load internal roles');
      }
    };

    loadInternalRoles();
  }, []);

  // Add useEffect to fetch external roles for configFilteredExternalRoles
    useEffect(() => {
      const loadConfigExternalRoles = async () => {
        try {
          const response = await axios.get(`${API_URL}/ConfigExternalRoles/LoadExternalRoles`);
          const roles = response.data.externalRoles;
  
          // Transform data for dropdown
          const options = roles.map(role => ({
            id: role.id,
            roleName: role.externalRoleName,
          }));
  
          setConfigExternalRoles(options);
          setConfigFilteredExternalRoles(options);
        } catch (error) {
          console.error('Error loading config external roles:', error);
         
        }
      };
  
      loadConfigExternalRoles();
    }, []);

    // Filter config external roles
    const filterConfigExternalRoles = (searchTerm) => {
        setConfigExternalRolesFilter(searchTerm);
    
        if (!searchTerm) {
          setConfigFilteredExternalRoles(configExternalRoles);
          return;
        }
    
        const filtered = configExternalRoles.map(role => {
          const matchesFilter = role.roleName.toLowerCase().includes(searchTerm.toLowerCase());
          return {
            ...role,
            visible: matchesFilter // Add a `visible` property to track filter visibility
          };
        });
    
        setConfigFilteredExternalRoles(filtered.filter(role => role.visible));
      };
  
  // Define the handleConfigExternalRoleCheckboxChange function
const handleConfigExternalRoleCheckboxChange = (roleId, checked) => {
  setConfigExternalRoles(prevRoles =>
    prevRoles.map(role =>
      role.id === roleId ? { ...role, selected: checked } : role
    )
  );

  setConfigFilteredExternalRoles(prevFilteredRoles =>
    prevFilteredRoles.map(role =>
      role.id === roleId ? { ...role, selected: checked } : role
    )
  );
};

 // Config - Map external roles
  const configMapExternalRoles = () => {
    if (!configSelectedInternalRole) {
      toast.error('Please select an internal role first');
      return;
    }

    // Clear existing roles in configMappedExternalRoles
    setConfigMappedExternalRoles([]);
    // Filter selected roles from configFilteredExternalRoles
    const selectedRoles = configFilteredExternalRoles.filter(role => role.selected);

    // Add selected roles to configMappedExternalRoles without duplicates
    const updatedMappedRoles = [];
    selectedRoles.forEach(role => {
      if (!updatedMappedRoles.some(mappedRole => mappedRole.id === role.id)) {
        updatedMappedRoles.push(role);
      }
    });

    setConfigMappedExternalRoles(updatedMappedRoles);

    // Update the state of configFilteredExternalRoles to keep checkboxes checked
    setConfigFilteredExternalRoles(configFilteredExternalRoles.map(role => {
      if (selectedRoles.some(selected => selected.id === role.id)) {
        return { ...role, selected: true };
      }
      return role;
    }));

    toast.success('External roles mapped successfully');
  };
  
  // Config - Unmap external roles
  const configUnmapExternalRoles = () => {
    if (!selectedMappedRole) {
      toast.error('Please select a role to unmap');
      return;
    }

    // Remove the selected role from configMappedExternalRoles
    const updatedMappedRoles = configMappedExternalRoles.filter(role => role.id !== selectedMappedRole);
    setConfigMappedExternalRoles(updatedMappedRoles);

    // Uncheck the role in configFilteredExternalRoles
    setConfigFilteredExternalRoles(configFilteredExternalRoles.map(role => {
      if (role.id === selectedMappedRole) {
        return { ...role, selected: false };
      }
      return role;
    }));

    // Clear the selected mapped role
    setSelectedMappedRole(null);

    toast.success('Role unmapped successfully');
  };

  // Update the handleSaveConfigExternalRoles function to reset the state after saving
  const handleSaveConfigExternalRoles = async () => {
    if (!configSelectedInternalRole) {
      toast.error('Please select an internal role to save mappings');
      return;
    }
  
    const payload = {
      internalRoleId: configSelectedInternalRole,
      mappedRoles: configMappedExternalRoles.map(role => ({
        externalRoleId: String(role.id),
        externalRoleName: String(role.roleName),
        externalRoleDesc: String(role.roleName), // Assuming description is same as role name
        checked: true,
        externalMappedId: String(role.id) // Assuming `externalMappedId` is the same as `externalRoleId`
      }))
    };
  
    try {
      const response = await fetch(`${API_URL}/ManageRoles/SaveConfigExternalRoleMapping`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });
  
      if (response.ok) {
        toast.success('Config external roles saved successfully');
  
        // Reset the state after saving
        setConfigSelectedInternalRole(null);
        setConfigMappedExternalRoles([]);
        setConfigFilteredExternalRoles(configExternalRoles.map(role => ({ ...role, selected: false })));
      } else {
        toast.error('Failed to save config external roles');
      }
    } catch (error) {
      // toast.error('An error occurred while saving config external roles');
    }
  };

   // Update the handleMappedRoleClick function to toggle background color on click
   const handleMappedRoleClick = (roleId) => {
    setSelectedMappedRole((prevSelected) => {
      // Toggle selection and update background color
      return prevSelected === roleId ? null : roleId;
    });
  };

  // Update useEffect to mark roles as checked in configFilteredExternalRoles based on fetchMappedRoles response
useEffect(() => {
  const fetchMappedRoles = async () => {
    if (!configSelectedInternalRole) return;

    try {
      const userId = sessionData?.userId;
      const response = await axios.get(`${API_URL}/ManageRoles/GetMappedRoles?internalRoleId=${configSelectedInternalRole}&userId=${userId}`);

      const mappedRoles = response.data.mappedExternalRoles;

      setConfigExternalRoles(prevRoles => {
        const updatedRoles = prevRoles.map(role => {
          const isMapped = mappedRoles.some(mappedRole => mappedRole.externalRoleId === String(role.id));
          return { ...role, selected: isMapped };
        });

        // Update filtered roles to reflect changes
        setConfigFilteredExternalRoles(updatedRoles);

        return updatedRoles;
      });

      // Update mapped external roles
      setConfigMappedExternalRoles(mappedRoles.map(mappedRole => ({
        id: mappedRole.externalRoleId,
        roleName: mappedRole.externalRoleName,
        selected: true
      })));
    } catch (error) {
      console.error('Error fetching mapped roles:', error);
      // toast.error('Failed to fetch mapped roles');
    }
  };

  fetchMappedRoles();
}, [configSelectedInternalRole]);

  
    return (
      <Panel title={
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
          <span style={{ flex: 1, textAlign: 'center' }}>Config External User Roles </span>
          <span
            style={{ position: 'absolute', right: 0, cursor: 'pointer' }}
            onClick={togglePanel}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                togglePanel();
              }
            }}
            tabIndex="0"
            role="button"
            aria-expanded={isPanelOpen}
            aria-label={`${isPanelOpen ? 'Collapse' : 'Expand'} Config External User Roles panel`}
          >
            {isPanelOpen ? '▼' : '▶'}
          </span>
        </div>
      }>
        {isPanelOpen && (
          <div>
          <div className="config-external-roles" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            {/* First Div: Select Internal Roles and Select External Roles */}
            <div style={{ flex: '1', marginRight: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                <label style={{ fontWeight: 'bold', marginRight: '10px', font: '12px Arial, Helvetica, sans-serif', color: '#666' }}>Select Internal Roles</label>
                <select 
                 
                  value={configSelectedInternalRole || ''} 
                  onChange={(e) => setConfigSelectedInternalRole(e.target.value ? Number(e.target.value) : null)}
                  style={{ width: '150px', padding: '5px', marginBottom: '5px' ,flex: '1', borderRadius: '4px', border: '1px solid #ccc' }}
                >
                  <option value="">Select</option>
                  {internalRoles.map(role => (
                    <option key={role.id} value={role.id}>{role.roleName}</option>
                  ))}
                </select>
              </div>

              <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '15px' }}>
                <label style={{ fontWeight: 'bold', marginRight: '10px', marginTop: '5px', font: '12px Arial, Helvetica, sans-serif', color: '#666' }}>Select External Roles</label>
                <div style={{ flex: '1' }}>
                  <input 
                    type="text" 
                    value={configExternalRolesFilter} 
                    onChange={(e) => filterConfigExternalRoles(e.target.value)}
                    placeholder="Filter External Roles..."
                    className="form-control"
                    style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <div className="roles-list" style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc', borderRadius: '4px', padding: '10px' }}>
                    <div className="role-item">
                      <input
                        type="checkbox"
                        id="select-all-config-external-roles"
                        checked={configFilteredExternalRoles.every(role => role.selected)}
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          setConfigFilteredExternalRoles(configFilteredExternalRoles.map(role => ({ ...role, selected: isChecked })));
                        }}
                      />
                      <label htmlFor="select-all-config-external-roles" style={{ font: '12px Arial, Helvetica, sans-serif', color: '#666' }}>Select All</label>
                    </div>
                    {configFilteredExternalRoles.map(role => (
                      <div key={role.id} className="role-item" style={{ marginBottom: '5px' }}>
                        <input 
                          type="checkbox" 
                          id={`config-ext-role-${role.id}`} 
                          value={role.id} 
                          checked={role.selected || false} 
                          onChange={(e) => handleConfigExternalRoleCheckboxChange(role.id, e.target.checked)}
                          style={{ marginRight: '10px' }}
                        />
                        <label htmlFor={`config-ext-role-${role.id}`} style={{ font: '12px Arial, Helvetica, sans-serif', color: '#666' }}>{role.roleName}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Second Div: Buttons */}
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: '0 10px' }}>
              <button className="btn button" style={{ marginBottom: '10px', padding: '5px 10px' }} onClick={configMapExternalRoles}>
                &gt;&gt;
              </button>
              <button className="btn button" style={{ padding: '5px 10px' }} onClick={configUnmapExternalRoles}>
                &lt;&lt;
              </button>
            </div>

            {/* Third Div: Mapped Roles */}
            <div style={{ flex: '1', marginLeft: '10px' }}>
              <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px', font: '12px Arial, Helvetica, sans-serif', color: '#666' }}>Mapped Roles</label>
              <div className="roles-list mapped-roles" style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #ccc', borderRadius: '4px', padding: '10px' }}>
                {configMappedExternalRoles.map(role => (
                  <div
                    key={role.id}
                    className={`role-item clickable ${selectedMappedRole === role.id ? 'selected' : ''}`}
                    onClick={() => handleMappedRoleClick(role.id)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleMappedRoleClick(role.id);
                      }
                    }}
                    tabIndex="0"
                    role="button"
                    aria-pressed={selectedMappedRole === role.id}
                    aria-label={`Select mapped role ${role.roleName}`}
                    style={{
                      marginBottom: '5px',
                      cursor: 'pointer',
                      backgroundColor: selectedMappedRole === role.id ? '#d3d3d3' : 'transparent',
                      borderRadius: '4px',
                      padding: '5px'
                    }}
                  >
                    {role.roleName}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div style={{ margin: '10px', textAlign: 'left', marginLeft: '20px' }}> {/* Added margin-left: 20px */}
            <button className="btn button" style={{ marginRight: '10px', padding: '8px 15px' }} onClick={handleSaveConfigExternalRoles}>
              Save
            </button>
            <button className="btn button" style={{ padding: '8px 15px' }}>Cancel</button>
          </div>
          </div>
        )}
        </Panel>
    )

}


export default ConfigExternalRoles;